<template>
    <div>
        <SideBarComp/>
        <NavBarComp/>
        <div class="content-wrap">
        <div class="main">
            <div class="section__content section__content--p30">
                <div class="container-fluid">  
                    <HeaderComp page="Evangelism Type" pageDesc="list of all evangelism types"/>                
                    <section id="main-content">
                        <div class="row ps-3 pe-3">
                            <div class="col-md-12">                               
                                <div class="row">

                                            <!-- <div class="col-1 text-end">
                                        <div class="d-flex align-items-center ml-4" style="min-width: 100px; float:right;">
                                            <label for="paginate" class="text-nowrap mr-2 mb-0"><strong>Per Page</strong></label>
                                            <select v-model.number.trim="perPage" class="form-control form-control-sm">
                                                <option value="20">20</option>
                                                <option value="2">2</option>
                                                <option value="40">40</option>
                                                <option value="60">60</option>
                                                <option value="80">80</option>
                                                <option value="100">100</option>
                                                <option value="120">120</option>
                                                <option value="140">140</option>
                                             </select>
                                       
                                        </div>
                                    </div> -->

                                    <PerPageComponent @perpageValue="perpageval" />

                                    <TableFilter @statusValue="statusval" portall="" />

                    

                                    <TableSearch @searchValue="searchval" />


                                  
    


                                    <ActionButton  @deleteRecords="deleteRecords" :num_checked="checked.length" portall="" />









                                
                                    <div class="col-2 text-end">
                                        <!-- <a class="btn btn-outline-success" @click="userAdd()" data-bs-toggle="modal"  href="#userModal">
                                            <i class="fas fa-plus"></i> Add User
                                        </a>    -->


                                                   
                                        <a class="btn btn-outline-success" @click.prevent="evangelism_typeAdd" ref="evangelism_type_add_ref" data-bs-toggle="modal"  href="#evangelism_typeModal">
                                            <i class="fas fa-plus"></i> Add Evangelism Type
                                        </a>   


                                           <a style="display:none" class="btn btn-outline-success" ref="evangelism_type_ref" data-bs-toggle="modal"  href="#evangelism_typeModal">
                                            <i class="fas fa-plus"></i> Evangelism Type Ref
                                        </a>   

                              

                                          <!-- <a class="btn btn-outline-success" style="display:none" ref="userEditEmployeeProviderModal" data-bs-toggle="modal" href="#userEmployeeProviderModal" >
                                            <i class="fas fa-plus"></i> Link User To Provider Portal
                                        </a>  -->
                                    </div>


                            


                                    <SelectAllComponent @selRecords="selectAllRecords" :num_checked="checked.length" v-if="selectPage" />


                                </div>
                            </div>
                            
                            <div class="card shadow-sm">
                                <div class="card-body">
                                    <div class="table-responsive table-responsive-data2">
                                        <table class="table table-hover table-striped">
                                            <thead>
                                                <tr>
                                               <th scope="col"><input type="checkbox" v-model="selectPage" /></th>
                                                <!-- <th scope="col">#</th> -->
                                                <th scope="col">
                                                <a href="#" @click.prevent="change_sort('evangelism_types.evangelism_type')">Evangelism Type</a>
                                                <span v-if="sort_direction=='desc' && sort_field=='evangelism_types.evangelism_type'">&uarr;</span>
                                                <span v-if="sort_direction=='asc' && sort_field=='evangelism_types.evangelism_type'">&darr;</span>
                                                </th>



                                                <th scope="col">
                                                 <a href="#" @click.prevent="change_sort('evangelism_types.from_date')">From Date</a>
                                                <span v-if="sort_direction=='desc' && sort_field=='evangelism_types.from_date'">&uarr;</span>
                                                <span v-if="sort_direction=='asc' && sort_field=='evangelism_types.from_date'">&darr;</span>
                                                </th>





                                                <th scope="col">
                                                 <a href="#" @click.prevent="change_sort('evangelism_types.to_date')">To Date</a>
                                                <span v-if="sort_direction=='desc' && sort_field=='evangelism_types.to_date'">&uarr;</span>
                                                <span v-if="sort_direction=='asc' && sort_field=='evangelism_types.to_date'">&darr;</span>
                                                </th>


                                                

                                                <th scope="col">
                                                 <a href="#" @click.prevent="change_sort('evangelism_types.is_active')">Is Active</a>
                                                <span v-if="sort_direction=='desc' && sort_field=='evangelism_types.is_active'">&uarr;</span>
                                                <span v-if="sort_direction=='asc' && sort_field=='evangelism_types.is_active'">&darr;</span>
                                                </th>

                                     

                                               


                                                <th scope="col">
                                                Action
                                                </th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(cru) in evangelism_types" :key="cru.id" :class="isChecked(cru.id) ? 'table-primary' : ''">
                                                <td>
                                                   <input type="checkbox" :value="cru.id"  v-model="checked"/> 
                                                </td>    
                                                <!-- <th scope="row">{{ index + 1}}</th> -->
                                                    <td>{{cru.evangelism_type}}</td>
                                                    <td>{{cru.from_date}}</td>
                                                    <td>{{cru.to_date}}</td>
                                                    <td>{{cru.is_active }}</td>
                                                    <td>
                                                        <div to="/" class="btn" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <i class="fa-solid fa-ellipsis position-relative"></i>
                                                        </div>
                                                        <div class="dropdown-menu text-small shadow" aria-labelledby="dropdownUser1">
                                                            <li class="d-flex">                                                    
                                                                <div class="btn"  title="edit" @click="evangelism_typeEdit(cru.id)">
                                                                    <i class="fa-solid fa-pencil"></i>
                                                                </div>                                                  
                                                                <div onclick="confirm('Are You Sure You Want To Delete This Record?') || event.stopImmediatePropagation()" class="btn" title="delete" @click="deleteSingleRecord(cru.id)">
                                                                    <i class="fa-solid fa-trash"></i>
                                                                </div>                                                  
                                                                <a class="btn" title="view" @click="evangelism_typeView(cru.id)">
                                                                    <i class="fa-solid fa-eye"></i>
                                                                </a>
                                                            </li>
                                                        </div>
                                                    </td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row mt-4">
                                             <VueTailwindPagination
                                            :current="currentPage"
                                            :total="total"
                                            :per-page="perpage"
                                            @page-changed="pageChange($event)"
                                            />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <FooterComp/>
                </div>
            </div>
        </div>
        </div> 

  

        <EvangelismTypeModals @evangelism_typeAdded="evangelism_typeAdded" :evangelism_type_view_type="evangelism_type_view_type" :evangelism_type_data="getevangelismTypeData"  />

        <!-- <UserModals @userAdded="userAdded"  @provider_view_typee="provider_view_typee"   @country_view_typee="country_view_typee"  :getUserPortalData="getUserPortalData"   :view_type="view_type"  />

        <EmployeeUserCountry @userView="userView" :employee_country_view_type="country_view_type" :employee_user_id="employee_user_id"  />    
  
        <EmployeeUserProvider @userView="userView"   :employee_provider_view_type="provider_view_type" :employee_provider_user_id="employee_provider_user_id" />      -->
        <!-- Modal -->
        <!-- <div class="modal fade" id="userModal" tabindex="-1" aria-labelledby="userModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="userModalLabel">Modal title</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                ...
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary">Save changes</button>
            </div>
            </div>
        </div>
        </div> -->
    </div>
</template>


<script>
// @ is an alias to /src
import HeaderComp from "@/components/HeaderComp.vue"
import FooterComp from "@/components/FooterComp.vue"
import SideBarComp from "@/components/SideBarComp.vue"
import NavBarComp from "@/components/NavBarComp.vue"
import PerPageComponent from "@/components/table/PerPage.vue"
import TableSearch from "@/components/table/TableSearch"
import TableFilter from "@/components/table/TableFilter"
import ActionButton from "@/components/table/ActionButton"
import SelectAllComponent from "@/components/table/SelectAllComponent"
import EvangelismTypeModals from "@/components/modalForms/EvangelismType.vue"
import axios from "axios"

//import "@ocrv/vue-tailwind-pagination/dist/style.css";
import VueTailwindPagination from "@ocrv/vue-tailwind-pagination";
import "@ocrv/vue-tailwind-pagination/styles";
import notificationBox from '@/services/notificationBox'
import {BASEURL} from '@/services/UserService';
import {  mapMutations, mapState } from 'vuex'
import { LOADING, TABLE_CURRENT_PAGE, TABLE_PER_PAGE, TABLE_SEARCH, TABLE_SEL_ALL, TABLE_SORT_FIELD_DIRECTION, TABLE_STATUS, TABLE_TOTAL, TABLE_URL } from '@/store/storeconstants'


export default {
  name: "EvangelismTypeView",
    beforeRouteEnter(to,from,next){
     let user_level = "";
     if(Array.isArray(JSON.parse(localStorage.getItem("user_portal_info")))) {
     const user_data = JSON.parse(localStorage.getItem("user_portal_info"));
     user_level = user_data[0].user_level;
     }
     else{
             const user_data = JSON.parse(localStorage.getItem("user_portal_info"));
             user_level = user_data.user_level;
     }
   
    
    if(user_level =='CHURCH ADMIN'){
        next();

    }else{
  
        next("/user-not-authorise"); 
    }
 
    
  },
  components: {
    HeaderComp, 
    FooterComp,
    SideBarComp, 
    NavBarComp,
    PerPageComponent,
    TableSearch,
    TableFilter,
    ActionButton,
    SelectAllComponent,
    VueTailwindPagination,
    EvangelismTypeModals

  },



  data(){
    return {
        evangelism_types:{},
        //showUserModals:false,

        //currentPage:1,
        //total:100,
        perPage:20,
        //perPage:20,
        search:"",
        is_active: "",
        checked:[],
        user_table_data:{},
        user_portal_table_data:{},
        getevangelismTypeData:{},
        evangelism_type_view_type:"",
        app_portal:"",
        user_portal_info:{},
        // provider_id:"",
        // country_view_type:"",
        // provider_view_type:"", 
        // employee_user_id:"",
        // employee_provider_user_id:"",
        // support_id:"",
        // dependent_id:"",
        // getSupportData:{},


        evangelism_type_id:"",
        login_user_id:"",
        user_level:"",
        church_id:"",
        selectPage:false,
        //selectAll:false,
     //   sort_direction: 'desc',
     //   sort_field: 'fullname',
      //  url:'',

    }
  },


  computed:{
    ...mapState('dataTable',['currentPage','url','total','perpage','getstatus','getsearch','selectAll','sort_direction','sort_field']),
    ...mapState("user_portal",['search_user_portal_id_result']),
    //...mapState("user",['search_user_id_result'])
  },



  methods:{

       ...mapMutations({
       table_select_all: 'dataTable/'+TABLE_SEL_ALL,
       table_sort_field_direction: 'dataTable/'+TABLE_SORT_FIELD_DIRECTION,
       table_current_page:'dataTable/'+TABLE_CURRENT_PAGE,
       table_url:'dataTable/'+TABLE_URL,
       table_per_page :'dataTable/'+TABLE_PER_PAGE,
       table_total :'dataTable/'+TABLE_TOTAL,
       table_search :'dataTable/'+TABLE_SEARCH,
       table_status :'dataTable/'+TABLE_STATUS,
       showLoading:LOADING,

     //  verified_username:'auth/'+SUCC_AUTH_VERIFY,
   }),




    selectAllRecords(){

        axios.get('evangelism_types/all?is_active=' + this.getstatus)
             .then(response => {
                 console.log(response.data);
                  this.checked = response.data;
                  // this.selectAll = true;
                 // this.table_checked(response.data);
                   this.table_select_all(true);
             });
    },



    change_sort(field){
        // if(this.sort_field == field){
        //  this.sort_direction =   this.sort_direction == "asc" ? "desc" : "asc"
        // }else{
        //     this.sort_field = field;
        // }
        this.table_sort_field_direction(field);
        this.getevangelismType();

    },



   deleteSingleRecord(id){

    //console.log(id);

       axios.delete(`evangelism_types/${id}`)
       .then( (response) => {
        this.checked = this.checked.filter(evangelism_type_id => evangelism_type_id != id)
        //this.table_checked(this.checked.filter(user_portal_id => user_portal_id != id))
        console.log(response.data.success)
        notificationBox.succNotifications("Deleted Successfully");
         this.getEvangelismType();
       }).catch(error => {
       // console.log(error)
         notificationBox.errorNotifications(error)
       })


   },



   deleteRecords(){
      axios.delete(`evangelism_types/massDestroy/${this.checked}`)
      .then((response) => {
         if(response.status == 204){
            console.log(response.data.success)
            notificationBox.succNotifications("Selected Evangelism Types were Deleted Successfully");
            this.checked = [];
            //this.table_checked([])
            this.getEvangelismType();

         }
      })
   },





   


    pageChange(pageNumber){

        //this.currentPage = pageNumber;
        this.table_current_page(pageNumber);
        this.getEvangelismType();

    },




   isChecked(id){

    return  this.checked.includes(id);

   },



    getEvangelismType(){
   
        axios.get(
            'evangelism_types?page=' + this.currentPage + 
            '&page_size=' + this.perpage + 
            '&q=' +this.getsearch + 
            '&is_active=' + this.getstatus +
            '&sort_direction=' + this.sort_direction +
            '&sort_field=' + this.sort_field +
            '&portal=' + this.app_portal +
            '&church_id=' + this.church_id 
            )
        .then(response => {

            this.evangelism_types = response.data.data.data;
            //this.perPage = response.data.data.per_page;
               this.table_per_page(response.data.data.per_page);
            //this.total = response.data.data.total;
             this.table_total(response.data.data.total)
        });

    },



    perpageval(value){
        this.table_per_page(value);
       this.getEvangelismType();

    },


    // banSucc(){

    //     this.getSupportMember();

    // },


    searchval(value){

         this.table_search(value);
        this.getEvangelismType();

    },

    statusval(value){

        this.table_status(value);
        this.getEvangelismType();

    },

 

   
   evangelism_typeEdit(evangelism_type_id){

    this.evangelism_type_id = evangelism_type_id;
    this.evangelism_type_view_type = "edit";
    this.getEvangelismTypeDataa(evangelism_type_id);
    this.$refs.evangelism_type_ref.click();

   },




    evangelism_typeView(evangelism_type_id)
    {

    this.evangelism_type_id = evangelism_type_id;
    this.evangelism_type_view_type = "view";
    this.getEvangelismTypeDataa(evangelism_type_id);
    
    this.$refs.evangelism_type_ref.click();

   },




      async getEvangelismTypeDataa(evangelism_type_id){
         
             this.showLoading(true);
             try{
            //   console.log("From Watchers",user_portal_id);
            //   console.log("From Props",this.get_user_portal_id);
            
            const response = await axios.get(`evangelism_types/${evangelism_type_id}`);
            this.showLoading(false);
                this.getevangelismTypeData = response.data.data;
                console.log(this.getEvangelismTypeData)
             }catch(error){
                console.log(error)
                this.showLoading(false);
             }
          
              },





    evangelism_typeAdd(){

        this.evangelism_type_view_type = "add";
        this.$refs.evangelism_type_add_ref.click();

     },






     evangelism_typeAdded(){
        this.getEvangelismType();
     },




  
  },





 async created(){
       
      
 if(Array.isArray(JSON.parse(localStorage.getItem("user_portal_info")))) {
                  this.app_portal = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal;
                this.district_id = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal_district_id;
                this.church_id = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal_church_id;
         }
         else
         {
       this.app_portal = JSON.parse(localStorage.getItem("user_portal_info")).portal;
this.district_id = JSON.parse(localStorage.getItem("user_portal_info")).portal_district_id;
this.church_id = JSON.parse(localStorage.getItem("user_portal_info")).portal_church_id;
//console.log(JSON.parse(localStorage.getItem("user_portal_info")))
         }

    //this.currentPage = 1;
    this.table_current_page(1);
   this.getEvangelismType();
  },


  watch:{


     "selectPage"(value){
         this.checked = [];
       //  this.table_checked([]);

        if(value){
            const evangelism_types = JSON.parse(JSON.stringify(this.evangelism_types));
            evangelism_types.forEach(evangelism_type=>{
                this.checked.push(evangelism_type.id)
                //this.table_checked_push(user.id);
            });
        
        }else{
              
              this.checked = [];
              //this.table_checked([]);
              //this.selectAll = false;
              this.table_select_all(false);
        }

     },

     "checked"(){

        this.table_url(BASEURL + "evangelism_types/export/"+ this.checked);
       // this.url = BASEURL + this.url + this.checked;

     }

  }

};
</script>